import { getPublicRouteUrl } from '@nackle/service-urls';

export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
